import * as React from 'react';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import CancelRenewalModalForm from './components/CancelRenewalModalForm';
import {bindActionCreators} from 'redux';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {actions as authActions, IAuthActions} from '../../../../services/auth/reducer';
import {IAuthState} from '../../../../services/auth/models';
import {actions as brandingActions} from '../../../../services/branding/reducer';
import {IBrandingActions, IBrandingState} from '../../../../services/branding/models';
import {destroy} from 'redux-form';
import { IStore } from '../../../../redux/IStore';

interface ISaveQuoteModalProps {
  auth: IAuthState;
  quote: IQuoteState;
  branding: IBrandingState;
  actions: {
    submit(name: string);
    push(path: string);
    quote: IQuoteActions;
    auth: IAuthActions;
    branding: IBrandingActions;
    destroy(formName: string);
  };
  disabled?: boolean;
  initQuote?: any;
  selectedQuote: any;
  handleEditQuote?: any;
  customerLapsed: boolean;
  toggleCustomerLapsed: any;
}

interface ISaveQuoteModalStates {
  showCancelRenewalModal: boolean;
  isQuoteSaved: boolean;
  submissionErrors: any;
  hideCancelButton: boolean;
}

class CancelRenewalModal extends React.Component<ISaveQuoteModalProps, ISaveQuoteModalStates> {

  public state = {
    showCancelRenewalModal: false,
    isQuoteSaved: false,
    submissionErrors: [],
    hideCancelButton: false,
  };

  public static defaultProps = {
    disabled: false,
  };

  private openCancelRenewalModal = () => {
    this.setState({
      showCancelRenewalModal: true,
    });
  }

  private handleCloseModal = () => {

    this.setState({
      showCancelRenewalModal: false,
    });

  }

  private showModal = () => {
    const { customerLapsed } = this.props;

    return !customerLapsed && false;
  }

  public render() {

    const { handleEditQuote, selectedQuote } = this.props;
    const {showCancelRenewalModal, isQuoteSaved} = this.state;

    if (!this.showModal()) {
      return null;
    }

    return (
      <div className="mt-15">
        <a
          className="return-to-account-btn"
          onClick={this.openCancelRenewalModal}
        >
          Cancel Your Renewal
        </a>

        <Modal show={showCancelRenewalModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Cancel Your Renewal</Modal.Title>
          </Modal.Header>
          <CancelRenewalModalForm
            onCloseModal={this.handleCloseModal}
            isQuoteSaved={isQuoteSaved}
            submissionErrors={this.state.submissionErrors}
            handleEditQuote={handleEditQuote}
            selectedQuote={selectedQuote}
            toggleCustomerLapsed={this.props.toggleCustomerLapsed}
            customerLapsed={this.props.customerLapsed}
          />
        </Modal>
      </div>
    );
  }
}

export default connect(
  (state: IStore) => {
    return {
      auth: state.auth,
      quote: state.quote,
      branding: state.branding,

    };
  },
  (dispatch) => ({
    actions: {
      auth: bindActionCreators({...authActions}, dispatch),
      quote: bindActionCreators({...quoteActions}, dispatch),
      branding: bindActionCreators({...brandingActions}, dispatch),
      destroy: bindActionCreators(destroy, dispatch),

    },
  }))(CancelRenewalModal);
